import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const SCHEDULED_EVENTS_SCHEDULED_EVENT_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/scheduled-events',
        iconClass: 'fas fa-calendar-alt',
        name: '::Menu:ScheduledEvents',
        layout: eLayoutType.application,
        requiredPolicy: 'Mandir.ScheduledEvents',
      },
    ]);
  };
}
